/* GUIDE DU CHAUSSANT (repense 2026-09-14) — bouton header "decouverte". Voir
   le commentaire en tete de snippets/guide-du-chaussant.liquid.

   2026-09-14i — REVELATION PROGRESSIVE DANS UNE SEULE VUE, identique mobile
   et desktop (retour utilisateur explicite, "pas sur un panneau") : Genre est
   visible des l'ouverture ; Stade reste cache tant que Genre n'est pas choisi
   puis apparait juste en dessous (les deux restent visibles ensemble, voir
   revealStade() pour l'animation d'apparition ajoutee le 2026-09-14j). Des
   que Stade est a son tour choisi, maybeNavigate() navigue immediatement —
   plus de bouton "Voir la selection" separe (2026-09-14h). Un CTA deja genre
   (banniere homepage, voir plus bas) masque le groupe Genre entierement et
   affiche direct le Stade. */
(function () {
  "use strict";

  var TARGET_COLLECTION_URL = "/collections/toutes-nos-chaussures";

  document.addEventListener("DOMContentLoaded", function () {
    var trigger = document.querySelector("[data-gdc-trigger]");
    var dropdown = document.querySelector("[data-gdc-dropdown]");
    if (!trigger || !dropdown) return;

    var state = { cibles: null, stade_motricite_detail: null };
    var genreGroup = dropdown.querySelector('[data-gdc-key-group="cibles"]');
    var stadeGroup = dropdown.querySelector('[data-gdc-key-group="stade"]');

    function updateSelected() {
      dropdown.querySelectorAll("[data-gdc-key]").forEach(function (btn) {
        var key = btn.dataset.gdcKey;
        btn.dataset.selected = state[key] === btn.dataset.gdcValue ? "true" : "false";
      });
    }

    // 2026-09-14j — petite apparition douce (voir @keyframes gdc-group-reveal
    // dans assets/guide-du-chaussant.css) plutot qu'un pop-in brutal quand le
    // Stade se devoile. La classe est retiree puis reposee a chaque appel
    // (offsetWidth force un reflow) pour rejouer l'animation meme si le
    // groupe etait deja visible (ex: reouverture du modal).
    function revealStade() {
      stadeGroup.hidden = false;
      stadeGroup.classList.remove("gdc__group--reveal");
      stadeGroup.offsetWidth;
      stadeGroup.classList.add("gdc__group--reveal");
    }

    function hideStade() {
      stadeGroup.hidden = true;
      stadeGroup.classList.remove("gdc__group--reveal");
    }

    // 2026-09-14h — remplace l'ancien bouton "Voir la selection" : appelee
    // apres chaque clic sur le Stade, navigue des que les 2 criteres requis
    // sont reunis (le dernier clic vaut validation).
    function maybeNavigate() {
      if (!(state.cibles && state.stade_motricite_detail)) return;
      var url = new URL(TARGET_COLLECTION_URL, window.location.origin);
      url.searchParams.set("filter.p.m.catalogue.cibles", state.cibles);
      url.searchParams.set("filter.p.m.catalogue.stade_motricite_detail", state.stade_motricite_detail);
      window.location.href = url.pathname + url.search;
    }

    function isOpen() {
      return !dropdown.hidden;
    }

    // presetGenre (optionnel) : "FILLE"/"GARCON" quand l'ouverture vient d'un
    // CTA deja genre (voir le listener #gdc-fille/#gdc-garcon plus bas) — dans
    // ce cas, le groupe Genre est masque entierement et le Stade apparait
    // direct. Une ouverture normale (sans argument, bouton header "Me guider")
    // retrouve toujours le flux complet Genre -> Stade.
    function open(presetGenre) {
      dropdown.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      if (presetGenre) {
        state.cibles = presetGenre;
        genreGroup.hidden = true;
        revealStade();
      } else {
        genreGroup.hidden = false;
        if (state.cibles) {
          revealStade();
        } else {
          hideStade();
        }
      }
      updateSelected();
    }

    function close() {
      dropdown.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    }

    trigger.addEventListener("click", function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });
    document.addEventListener("click", function (e) {
      if (!isOpen()) return;
      if (trigger.contains(e.target) || dropdown.contains(e.target)) return;
      close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) close();
    });

    dropdown.querySelectorAll('[data-gdc-key="cibles"]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.cibles = state.cibles === btn.dataset.gdcValue ? null : btn.dataset.gdcValue;
        updateSelected();
        if (state.cibles) {
          revealStade();
        } else {
          hideStade();
        }
      });
    });

    dropdown.querySelectorAll('[data-gdc-key="stade_motricite_detail"]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.stade_motricite_detail =
          state.stade_motricite_detail === btn.dataset.gdcValue ? null : btn.dataset.gdcValue;
        updateSelected();
        if (state.stade_motricite_detail != null) maybeNavigate();
      });
    });

    // 2026-09-14f/g — CTA "Fille"/"Garcon" de la banniere homepage
    // (templates/index.json, section hero > button_url_1/2 pointent vers les
    // ancres #gdc-fille / #gdc-garcon plutot que vers une vraie URL) : le
    // genre est deja choisi par ce clic. Delegation sur document : ces liens
    // vivent dans une tout autre section du DOM, hors de .gdc-dropdown.
    document.addEventListener("click", function (e) {
      var cta = e.target.closest('a[href="#gdc-fille"], a[href="#gdc-garcon"]');
      if (!cta) return;
      e.preventDefault();
      open(cta.getAttribute("href") === "#gdc-fille" ? "FILLE" : "GARCON");
    });
  });
})();
